import React, { useState } from "react";
import l from "components/util/l";
import Modal from "seed/helpers/Modal";
import { resolveFileUrl } from "components/brief/util/fileUrl";
import { SCREENSHOT_ANNOTATION } from "components/brief/util/prototypeAnnotations";

const getVisibilityScopeLabel = (visibilityScope) =>
  visibilityScope == "DEV"
    ? l("Desarrollo%PA481")
    : l("Cliente%PA479");

// One comment in the prototype panel, the same card on both prototype screens: the
// builder's and the reviewer's. A comment made by pointing at the rendered page carries
// the framed capture, which is most of what it says — so the thumbnail sits above the
// text and opens full size, and the words below it stay editable in place.
const PrototypeAnnotation = ({
  draftText = "",
  isDeveloper = false,
  isEditing = false,
  annotation,
  onChangeDraftText,
  onChangeResolvedState,
  onClickCancelEditing,
  onClickRemove,
  onClickSaveEditing,
  onClickStartEditing,
}) => {

  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);

  const isResolved = !!annotation.is_solved;
  const isScreenshot = annotation.type == SCREENSHOT_ANNOTATION;
  const screenshotUrl = resolveFileUrl(annotation.screenshot?.url);

  return <>
    <div
      className="rounded p-3 mb-3"
      style={{
        background: isResolved ? "#f3f4f6" : "#ffffff",
        border: "1px solid #e5e7eb",
        opacity: isResolved ? 0.78 : 1,
      }}
    >
      <div className="d-flex align-items-start mb-2">
        <span
          className="badge border-0 px-2 mr-2"
          style={{
            borderRadius: "0.375rem",
            fontSize: 12,
            backgroundColor: isScreenshot ? "#e0f0ff" : "#fff3d6",
            color: isScreenshot ? "#0b5394" : "#8a6200",
          }}
        >
          <i className={`fas ${isScreenshot ? "fa-crop-simple" : "fa-code"} mr-1`}></i>
          {annotation.annotationNumber}
        </span>

        <div className="flex-fill overflow-hidden">
          <div className="font-weight-bold text-dark text-truncate">
            {isScreenshot
              ? l("Comentario en pantalla%BR008")
              : l("Comentario adicional%PA504")}
          </div>
          {isDeveloper && (
            <small className="text-muted">
              {getVisibilityScopeLabel(annotation.visibility_scope || "CLIENT")}
            </small>
          )}
        </div>

        <button
          type="button"
          className="btn btn-xs p-0 mr-2"
          title={isResolved ? l("Marcar como pendiente%BR054") : l("Marcar como resuelto%BR055")}
          onClick={() => onChangeResolvedState(annotation, !isResolved)}
        >
          <i className={`fas ${isResolved ? "fa-check-circle text-success" : "fa-check text-primary"}`}></i>
        </button>

        <button
          type="button"
          className="btn btn-xs p-0 text-danger"
          title={l("Eliminar%GA001")}
          onClick={() => onClickRemove(annotation)}
        >
          <i className="fas fa-trash-alt"></i>
        </button>
      </div>

      {!!screenshotUrl && (
        <div
          role="button"
          className="border rounded overflow-hidden mb-2 d-flex align-items-center justify-content-center position-relative"
          style={{ height: 130, background: "#f8fafc" }}
          title={l("Ver captura%BR009")}
          onClick={() => setIsFullscreenOpen(true)}
        >
          <img
            src={screenshotUrl}
            alt={l("Captura del prototipo%BR010")}
            className="w-100 h-100"
            style={{ objectFit: "contain" }}
          />
          <span
            className="position-absolute px-2 py-1 rounded text-white"
            style={{ right: 6, bottom: 6, fontSize: "0.7rem", background: "rgba(15, 23, 42, 0.65)" }}
          >
            <i className="fas fa-expand mr-1"></i>
            {l("Ver captura%BR009")}
          </span>
        </div>
      )}

      {!isEditing && (
        <div
          className="small text-dark p-2 rounded d-flex align-items-start"
          style={{ background: "#f8fafc", lineHeight: 1.45 }}
        >
          <div
            role="button"
            className="flex-fill"
            style={{ whiteSpace: "pre-wrap" }}
            onClick={() => onClickStartEditing(annotation)}
          >
            {annotation.text || l("Escribe un comentario...%PA541")}
          </div>

          <button
            type="button"
            className="btn btn-xs p-0 ml-2 text-primary flex-shrink-0"
            title={l("Editar%GA002")}
            onClick={() => onClickStartEditing(annotation)}
          >
            <i className="fas fa-pen"></i>
          </button>
        </div>
      )}

      {isEditing && (
        <>
          <textarea
            className="form-control form-control-sm"
            rows={4}
            value={draftText}
            autoFocus
            placeholder={l("Escribe un comentario...%PA541")}
            onChange={onChangeDraftText}
          />
          <div className="d-flex justify-content-end mt-2">
            <button type="button" className="btn btn-link btn-sm mr-2" onClick={onClickCancelEditing}>
              {l("Cancelar%GA021")}
            </button>
            <button type="button" className="btn btn-primary btn-sm" onClick={() => onClickSaveEditing(annotation)}>
              {l("Guardar%GA023")}
            </button>
          </div>
        </>
      )}
    </div>

    {isFullscreenOpen && (
      <Modal
        width={window.innerWidth - 96}
        height={window.innerHeight - 96}
        overflow="hidden"
        onClose={() => setIsFullscreenOpen(false)}
      >
        <div className="h-100 d-flex align-items-center justify-content-center bg-dark p-3">
          <img
            src={screenshotUrl}
            alt={l("Captura del prototipo%BR010")}
            className="mw-100 mh-100"
            style={{ objectFit: "contain" }}
          />
        </div>
      </Modal>
    )}
  </>;

};

export default PrototypeAnnotation;
